export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    category: "angular velocity",
    groups: [],
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "angularVelocity",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          name: "direction",
        },
      ],
    },
  },
);
